import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { API_AUTH_URI } from "../../constants";
import "./LoginForm.scss";

interface LocationState {
  from: string;
}

export default function Login() {
  const location = useLocation();
  const state = location.state as LocationState;
  const { t } = useTranslation();

  return (
    <div>
      <div className="container login-container bg-white d-flex border-bottom rounded-bottom rounded-top justify-content-start">
        <div className="child-container container bg-white d-flex justify-content-center align-items flex-column">
          <Button
            onClick={() => {
              window.location.href =
                API_AUTH_URI +
                "?relayState=" +
                encodeURI(state ? state.from : window.location.origin);
            }}
          >
            {t("Login with Google")}
          </Button>
        </div>
      </div>
    </div>
  );
}
